module.exports = __webpack_public_path__ + "img/vizio3-cover-2.64912316.jpg";